import Cookies from 'js-cookie'

const TokenKey = 'loginTokenAdmin'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,{
    expires: 7,       // 30天后过期
    // path: '/',         // 全站生效
    // secure: true,      // 仅HTTPS传输（生产环境建议开启）
    // sameSite: 'Lax'    // 防止CSRF攻击
  })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getDataToken() {
  let token = Cookies.get(TokenKey) ? Cookies.get(TokenKey) : ''
  token = token.replace('Bearer ','')
  return token
}



// WEBPACK FOOTER //
// ./src/utils/auth.js